import React, { CSSProperties } from 'react';
import { Progress, Toast, ToastHeader, ToastBody } from 'reactstrap';
import { useDownloaderContext } from './DownloadProvider';

const toastStyle: CSSProperties = {position: "absolute", top: 54, right: 22, width: 150, zIndex: 500, };
export interface DownloaderProps {
}

export const Downloader: React.FC<DownloaderProps> = () => {


  const { downloads } = useDownloaderContext();

  return (
    <div className="mt-3 mb-2 ml-3 mr-3" style={toastStyle}>

      {downloads.map((d) => {
        return (
          <Toast key="asdf" isOpen={true}> 
            <ToastHeader>
              Downloads
            </ToastHeader>
            <ToastBody>
              <Progress animated value={d.progress}>Erstelle Gesamtliste</Progress>
            </ToastBody>
          </Toast>
        )
      })}
      
    </div>
  );

}
